import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";

var Asset = function Asset(_ref) {
  var border = _ref.border,
      caption = _ref.caption,
      children = _ref.children;
  var getClassName = getClassNameFactory(Asset.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        border: border
      })
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "caption"
    })
  }, caption));
};

Asset.propTypes = {
  /**
   * Render an optional border around the asset
   */
  border: PropTypes.bool,

  /**
   * A caption to attach to the asset. Children should be restricted to text,
   * <a>, <em> and <strong>
   */
  caption: PropTypes.node,

  /**
   * The asset. Children should be restricted to Image or VideoPlayer
   */
  children: PropTypes.node.isRequired
};
Asset.displayName = "Longform.Asset";
export default Asset;